var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialProfileSolid = function SvgSocialProfileSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C9.00142 16 9.95986 15.816 10.8434 15.48C10.6473 15.1356 10.5096 14.7537 10.4439 14.3476C9.68545 14.6398 8.86145 14.8 8.00005 14.8C6.31963 14.8 4.78157 14.1905 3.59492 13.1804C4.17307 11.4268 5.96574 10.2 8.00005 10.2C9.28039 10.2 10.465 10.686 11.3114 11.4834C11.9321 10.8168 12.8174 10.4 13.8 10.4C14.411 10.4 14.9844 10.5612 15.48 10.8434C15.816 9.95986 16 9.00142 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.00005 3.8C6.67456 3.8 5.60005 4.87452 5.60005 6.2C5.60005 7.52548 6.67456 8.6 8.00005 8.6C9.32553 8.6 10.4 7.52548 10.4 6.2C10.4 4.87452 9.32553 3.8 8.00005 3.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 16C15.015 16 16 15.015 16 13.8C16 12.585 15.015 11.6 13.8 11.6C12.585 11.6 11.6 12.585 11.6 13.8C11.6 15.015 12.585 16 13.8 16Z",
    fill: "currentColor"
  })));
};
export default SvgSocialProfileSolid;